var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutobusesAdo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1134 330",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97,0.924L85,78.924L54,78.924L67,0.924L97,0.924Z",
    style: {
      fill: "rgb(237,31,36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,0.924L128,78.924L97,78.924L110,0.924L141,0.924Z",
    style: {
      fill: "rgb(237,31,36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,78.924C141.017,53.608 144.173,26.431 149,0.924C201.941,5.143 180.818,80.943 136,78.924Z",
    style: {
      fill: "rgb(237,31,36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,0.924L233,0.924L221,78.924C167.757,78.348 187.906,0.915 230,0.924L231,0.924Z",
    style: {
      fill: "rgb(237,31,36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,78.924L241.375,0.924C292.284,5.328 273.67,81.739 229,78.924Z",
    style: {
      fill: "rgb(237,31,36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,3.924L46,78.924L0,78.924L57,3.924Z",
    style: {
      fill: "rgb(237,31,36)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutobusesAdo);
export default __webpack_public_path__ + "static/media/Autobuses_ADO.c260d0be245e300bd7b7162ef04e48e1.svg";
export { ForwardRef as ReactComponent };